import { OrgCard } from "./org_card";

const LINE_COLOR = "#d0daea";
const LINE_THICKNESS = 2;

export function OrgChartMobile({ ceo, directReports, subReports, izzanIndex }) {
  const INDENT = 24;

  const NodeRow = ({
    anggota,
    level = 0,
    size = "md",
    highlight = false,
    isLast = false,
  }) => (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        marginLeft: level * INDENT,
        marginBottom: 8,
        position: "relative",
      }}
    >
      {level > 0 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            marginRight: 8,
            width: 16,
            flexShrink: 0,
            paddingTop: 20,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: level * INDENT - INDENT + 8,
              width: LINE_THICKNESS,
              height: isLast ? 22 : "100%",
              background: LINE_COLOR,
            }}
          />
          <div
            style={{
              position: "absolute",
              top: 20,
              left: level * INDENT - INDENT + 8,
              width: INDENT - 8,
              height: LINE_THICKNESS,
              background: LINE_COLOR,
            }}
          />
        </div>
      )}
      <OrgCard anggota={anggota} size={size} highlight={highlight} />
    </div>
  );

  return (
    <div style={{ padding: "0 8px", position: "relative" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: 16,
        }}
      >
        {ceo && <OrgCard anggota={ceo} size="lg" highlight />}
      </div>

      <div
        style={{
          width: LINE_THICKNESS,
          height: 20,
          background: LINE_COLOR,
          margin: "0 auto 0",
        }}
      />

      <div style={{ position: "relative", paddingTop: 8 }}>
        {directReports.map((person, idx) => {
          const isIzzan = idx === izzanIndex;
          const isLastDirect = idx === directReports.length - 1;

          return (
            <div key={idx} style={{ position: "relative" }}>
              <NodeRow
                anggota={person}
                level={1}
                size="md"
                highlight={isIzzan}
                isLast={isLastDirect && !isIzzan}
              />

              {isIzzan && subReports.length > 0 && (
                <div style={{ position: "relative" }}>
                  {subReports.map((sub, si) => (
                    <NodeRow
                      key={si}
                      anggota={sub}
                      level={2}
                      size="sm"
                      isLast={si === subReports.length - 1}
                    />
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
